module.exports = __webpack_public_path__ + "img/xsky.ef383e70.svg";